<template>
  <div class="my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 maxw-1750">
    <h2> {{ $t('menu.approvals') }}</h2>
    <v-card>
      <v-row
        no-gutters
        align="center"
        class="px-4 mt-4"
      >

        <!-- SELECT -->
        <v-col cols="12" md="5" class="pr-md-6">
          <SelectField
            class="white mb-2"
            :disableOutlined="true"
            :disabled="loading"
            :label="properties.label"
            :params="selectProperties"
            :fromApprovalList="true"
            @update:inputData="onApplicationsSelected"
          />
        </v-col>

        <!-- SEARCH -->
        <v-col cols="9" md="5" class="pr-md-2">
          <Searchbar
            ref="filterComponent"
            :placeholder="$t('views.approveList.search.placeholder')"
            @search="submit"
          />
        </v-col>

        <!-- BUTTON -->
        <v-col cols="3" md="2" class="d-flex justify-end">
          <v-btn
            color="primary"
            :class="['my-3 ml-4', { primary: expandSearchFilters }]"
            icon
            @click="expandSearchFilters = !expandSearchFilters"
          >
            <v-icon :class="{ 'white--text': expandSearchFilters }">
              mdi-tune
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <!-- Filtros Inputs Aprobaciones -->
      <v-expand-transition>
        <v-card-text id="list-filters-item" v-show="expandSearchFilters">
          <FormApprovals
            v-if="listFilters && listFilters.length > 0"
            id="form-filters"
            ref="formFilters"
            :data="rangeFilter === 'PEND_APRO' ?
              formFiltersConfigurationPendApro(formFiltersConfiguration) : rangeFilter === 'RCHZ' ?
              formFiltersConfigurationRchz(formFiltersConfiguration) :
              formFiltersConfigurationAppval(formFiltersConfiguration)"
            :buttons="[$t('views.ticketList.filters.search')]"
            @click:submit="submit"
            @keyup.enter="submit"
          ></FormApprovals>
        </v-card-text>
      </v-expand-transition>

      <!-- Nuevo Filtro Aprobaciones Chips -->
      <v-row
        no-gutters
        align="center"
        justify="start"
        v-show="expandSearchFilters"
        class="pb-1"
      >
        <v-sheet
          class="mb-1 mt-1 showWeb"
          :style="{ background: 'none' }"
        >
          <div class="container__chip">
            <span
              v-for="(filterItem, i) of listFilters"
              :key="i"
              :class="[filterItem.active
                ? 'chip__active'
                : '', 'chip__agrupaciones chip__filter v-chip']"
            >
            <v-badge
              :key="`badge-${i}`"
              class="d-inline"
              inline
              :color="filterItem.label ? colors(filterItem.label) : ''"
              dot
            ></v-badge>
              <span :id="filterItem.label" @click="clickChip(filterItem.label)">
                {{ $t(`views.approveList.filterItem.${filterItem.label}`) }}
              </span>
            </span>
          </div>
        </v-sheet>

        <v-slide-group
          class="showMobile"
          multiple
          show-arrows
        >
          <v-slide-item
            v-for="(filterItem, i) in listFilters"
            :key="i"
            :class="[filterItem.active
              ? 'chip__active'
              : '', 'chip__agrupaciones chip__filter v-chip']"
          >
            <v-badge
              :key="`badge-${i}`"
              class="d-inline"
              inline
              :color="filterItem.label ? colors(filterItem.label) : ''"
              dot
            ></v-badge>
            <span @click="clickChip(filterItem.label)">
              {{ $t(`views.approveList.filterItem.${filterItem.label}`) }}
            </span>
          </v-slide-item>
        </v-slide-group>

        <!-- EXPORT ACTION -->
        <!-- MOBILE_DISABLED_EXPORT -->
        <div class="exportActions">
          <v-btn
            v-if="$vuetify.breakpoint.mdAndUp && get('deviceOS') == null"
            v-show="Number(this.total) && firstLoadDone"
            color="primary"
            outlined
            :disabled="exportLoading"
            @click="exportTickets()"
          >
            <v-icon class="mr-2">mdi-file-excel</v-icon>
            {{ $t("views.ticketList.export") }}
          </v-btn>
        </div>
      </v-row>

    </v-card>

    <!-- LIST SKELETON LOADER -->
    <div class="list-tickets-loading mt-4" v-if="!firstLoadDone">
      <v-card v-for="i in 10" :key="`divider-${i}`" class="mx-0" tile>
        <v-skeleton-loader :key="`loading-${i}`" type="list-item-three-line">
        </v-skeleton-loader>
      </v-card>
    </div>
    <!-- END LIST SKELETON LOADER -->

    <template v-if="firstSearch && Number(this.total) === 0">
      <v-col cols="12">
        <span v-html="$t('views.globalSearch.requestsItems.notFoundSearchFirstLoad')"></span>
      </v-col>
    </template>
    <template v-else>
      <v-col v-if="firstLoadDone && Number(this.total) === 0" cols="12">
        <span v-html="$t('views.globalSearch.requestsItems.notFoundSearch', [dataSearch])"></span>
      </v-col>
    </template>
    <!-- ACTIONS LIST APPROVALS -->
    <template v-if="filteredTickets && filteredTickets.length > 0
    && filteredTickets[0].status.code === 'PEND_APRO'">
      <row v-show="Number(this.total) && firstLoadDone" cols="12">
        <v-col class="pb-0">
          <v-chip class="ma-2" color="primary" label @click="ckeckAll()">
            <v-icon left v-if="checkAll"> mdi-checkbox-blank </v-icon>
            <v-icon left v-else> mdi-checkbox-marked </v-icon>
            <span v-if="checkAll">{{ $t("views.approveList.uncheckAll") }} </span>
            <span v-else>{{ $t("views.approveList.checkAll") }} </span>
          </v-chip>
          <v-chip
            v-if="$vuetify.breakpoint.mdAndUp && selected.length > 0"
            class="ma-2"
            color="green"
            label
            text-color="white"
            @click="openAproveAll()"
          >
            {{ $t("views.approveList.approverSelect") }}
          </v-chip>
          <v-chip
            v-if="$vuetify.breakpoint.mdAndUp && selected.length > 0"
            class="ma-2"
            color="red"
            label
            text-color="white"
            @click="openRejectAll()"
          >
            {{ $t("views.approveList.rejectSelect") }}
          </v-chip>
          {{ /* MENU APPROVERALL */ }}
          <v-card-text v-show="showApproveAll">
            <ApproveAll
              :tickets="selected"
              @refresh:list="refresh()"
              @close="closeActionsAll()"
            >
            </ApproveAll>
          </v-card-text>
          {{ /* MENU REJECTALL */ }}
          <v-card-text v-show="showRejectAll">
            <RejectAll
              :tickets="selected"
              @refresh:list="refresh()"
              @close="closeActionsAll()"
            >
            </RejectAll>
          </v-card-text>
        </v-col>
      </row>
    </template>
    <!-- floating action buttons MOVILE-->
    <v-speed-dial
      v-if="!$vuetify.breakpoint.mdAndUp && firstLoadDone
      && filteredTickets && filteredTickets.length > 0
      && filteredTickets[0].status.code === 'PEND_APRO'"
      v-model="fab"
      bottom
      right
      direction="top"
      transition="slide-y-reverse-transition"
      class="align-end"
      :style="{
          position: 'fixed',
          bottom: '70px',
          zIndex: '20',
        }"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>

      <div class="d-flex flex-nowrap align-center">
        <v-btn
          class="rounded-pill"
          color="green"
          dark
          @click.stop="openAproveAll()"
        >
          <v-icon>mdi-checkbox-marked-outline</v-icon>
        </v-btn>
      </div>
      <div class="d-flex flex-nowrap align-center">
        <v-btn
          class="rounded-pill"
          color="red"
          dark
          @click.stop="openRejectAll()"
        >
          <v-icon>mdi-close-box-outline</v-icon>
        </v-btn>
      </div>
    </v-speed-dial>

    <div class="mt-4" v-if="firstLoadDone">
      <!-- TICKET ROUTER LINK DETAIL-->

      <!-- TICKETS LIST DETAILS -->
      <ListItem
        v-for="(ticket, index) in filteredTickets"
        :key="index"
        :url="`${goDetail}/${ticket.id}`"
      >

        <template v-slot:title>
          <div class="inlineFlexMW90 pt-2">
            <div class="alignItemCenter titleTicket">
              {{ /* Inicial tipo solicitud */ }}
              <v-avatar
                v-if="ticket.status != null"
                class="initialColor mr-1"
                :color="ticket.status.code ? colors(ticket.status.code) : ''"
                size="32"
              >
                <v-icon
                  class="initialColorIcon"
                  :color="colors(ticket.status.code)"
                  v-text="textIcon(ticket)"
                ></v-icon>
              </v-avatar>
              {{ /* Check Seleccionar */ }}
              <v-checkbox
                v-if="filteredTickets && filteredTickets.length > 0
                && filteredTickets[0].status.code === 'PEND_APRO'"
                class="px-0 m-0 ml-2"
                v-model="selected"
                :value="ticket"
                color="primary"
                @click.prevent
                hide-details
              >
              </v-checkbox>
              {{ /* Numero referencia y resumen */ }}
              <span
                v-if="$vuetify.breakpoint.mdAndUp"
                v-bind:class="['item-title', {
                  'item-title-end': !$vuetify.breakpoint.smAndUp
                }]"
              >
                <!-- <i v-if="!pathSelect()"> {{ ticket.referenceNumber }}</i> - -->
                <i class="titleTicket"> {{ ticket.referenceNumber }}</i> -
                {{ ticket.summary }}
              </span>

              <v-spacer />

              <span
                v-if="!$vuetify.breakpoint.mdAndUp"
                style="width: 100%"
                v-bind:class="['item-title', {
                  'item-title-end': !$vuetify.breakpoint.smAndUp
                }]"
              >
              <i class="titleTicket"> {{ ticket.referenceNumber }}</i> -
                {{ ticket.summary }}
              </span>
              <v-spacer />
              <!-- <span class="ma-2" label style="float: right" small color="primary">
                {{
                  $te(`views.ticketList.status.${ticket.status.relAttr}`)
                    ? $t(`views.ticketList.status.${ticket.status.relAttr}`)
                    : $t(`views.home.pendingRequests.statuses.${ticket.status.code}`)
                }}
              </span> -->
            </div>
          </div>
        </template>

        <template v-slot:subtitle>
          <div  v-if="ticket.description" v-html="ticket.description.replace(/\n/gi, '<br>')"></div>
          <v-spacer />
          <v-chip class="mt-2" label small color="accent">
            <v-icon left small> mdi-book </v-icon>
            {{ ticket.category.name }}
          </v-chip>
          <v-chip class="mt-2 ml-2" label small color="primary">
            <v-icon left small> mdi-tag </v-icon>
            {{ ticket.assignee.name }}
          </v-chip>
        </template>

        <template v-slot:footer class="pa-1">
          <v-row>
            <v-col md="16">
              <template v-if="ticket.openDate">
                {{
                  $t("views.ticketList.openDate", [
                    $date("formatTime", ticket.openDate),
                  ])
                }}
              </template>

              <template v-if="ticket.lastModDt">
                {{
                  $t("views.ticketList.lastModDt", [
                    $date("formatTime", ticket.lastModDt),
                  ])
                }}
              </template>

              <template v-if="ticket.resolveDate">
                {{
                  $t("views.ticketList.resolveDate", [
                    $date("formatTime", ticket.resolveDate),
                  ])
                }}
              </template>

              <template
                v-if="
                  (ticket.status || {}).relAttr === 'CL' && ticket.closeDate
                "
              >
                {{
                  $t("views.ticketList.closeDate", [
                    $date("formatTime", ticket.closeDate),
                  ])
                }}
              </template>

              <span v-if="(ticket.customer || {}).location != null">
                {{
                  $t("views.ticketList.locationTicket", [
                    ticket.customer.location.name,
                  ])
                }}
              </span>

              <span v-if="hasRoles(NAMED_ROLES.VIEW_MANAGEMENT)">
                {{
                  $tc(
                    "views.ticketList.asignee",
                    getAsignee(ticket).length,
                    getAsignee(ticket)
                  )
                }}
              </span>
            </v-col>
          </v-row>
        </template>

          <!-- MENU APPROVE/REJECT -->
        <template v-if="filteredTickets && filteredTickets.length > 0
          && filteredTickets[0].status.code === 'PEND_APRO'" v-slot:menuAction class="pa-0" >
          <div @click.prevent>
            <ActionsApprove
              right
              :ticket="ticket"
              @refresh:list="refresh()"
            >
            </ActionsApprove>
          </div>
        </template>

      </ListItem>

      <!-- <InfiniteScroll
        v-if="firstLoadDone && total > 25 && (loading || pagesize < total)"
        :scroll="loading && firstLoadDone"
        margin="400px"
        root="html"
        class="mt-4"
        @scrollList="scrollTickets(10)"
      ></InfiniteScroll> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { saveAs } from 'file-saver';
import moment from 'moment';
import {
  ListItem,
  Searchbar,
  FormApprovals,
  /* InfiniteScroll, */
  ApproveAll,
  RejectAll,
  ActionsApprove,
} from '@/components';

import { NAMED_ROLES } from '@/store/modules/session';
import SelectField from '../components/form/field-types/Select.vue';

const b64toBlob = function b64toBlob(b64Data, contentType, sliceSize) {
  const content = contentType || '';
  const size = sliceSize || 512;

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += size) {
    const slice = byteCharacters.slice(offset, offset + size);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: content,
  });
  return blob;
};

export const FIELD_TYPES = {
  approve: 'Approve',
  reject: 'Reject',
};

export default {
  name: 'ApprovalsListView',
  components: {
    ListItem,
    Searchbar,
    FormApprovals,
    /* InfiniteScroll, */
    ApproveAll,
    RejectAll,
    ActionsApprove,
    SelectField,
  },
  props: {
    ticketType: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    sort: {
      type: String,
      default: () => 'open_date',
    },
    asc: {
      type: Boolean,
      default: () => false,
    },
    loading: Boolean,
    firstLoadDone: Boolean,
    goDetail: {
      type: String,
      default: () => '/requests',
    },
  },
  data() {
    return {
      start: 0,
      pagesize: 25,
      expandSearchFilters: false,
      exportLoading: false,
      selected: [],
      checkAll: false,
      showApproveAll: false,
      showRejectAll: false,
      componentsActions: null,
      fab: false,
      openApprover: false,
      openReject: false,
      scroll: true,
      dataSearch: '',
      firstSearch: false,
      listFilters: [],
      filtersForms: {},
      rangeFilter: 'PEND_APRO',
      properties: {
        alias: 'CISearch',
        label: 'Aplicación',
        config: {
          hint: 'Aplicación',
          component: 'cisearch',
        },
        params: {
          multiple: 'true',
          value: 'value',
          alias: 'CISearch',
        },
        specials_values:
        {
          type: 'relation',
        },
        type: {
          name: 'search',
          ZCODE: 'search',
        },
      },
      selectedCI: [],
      applications: [],
    };
  },
  watch: {
    resourceList(newResourceList) {
      const validValues = new Set(
        newResourceList.map((item) => item.value),
      );

      this.selectedCI = this.selectedCI.filter(
        (value) => validValues.has(value),
      );
    },
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
      get: 'globalState/get',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
      resourceList: ({ tickets }) => tickets.resourceList,
    }),
    formFiltersConfiguration() {
      // getting base configuration from constants
      const filtersConfiguration = this.$getConst('listFilters.approvals');

      // we will check if there's some property initialized by url parameter
      Object.keys(this.filtersForms)
        .map((filterKey) => filtersConfiguration.properties.find((f) => f.alias === filterKey))
        .filter((filterProperty) => filterProperty != null)
        .forEach((filterProperty) => {
          let value = this.filtersForms[filterProperty.alias];
          let initialvalue = null;
          if (['date', 'datetime'].includes(filterProperty.type.name)) {
            value = value
              .split('::')
              .map((filterValue) => moment(filterValue, 'DD/MM/YYYY').format('YYYY-MM-DD'));

            if (value.length <= 2) {
              initialvalue = `'${value.join('::')}'`;
            }
          } else {
            initialvalue = Array.isArray(value)
              ? JSON.stringify(value)
              : `'${value}'`;
          }

          if (initialvalue != null) {
            // eslint-disable-next-line no-param-reassign
            filterProperty.config.initialvalue = initialvalue;
          }
        });
      return filtersConfiguration;
    },
    tickets() {
      let data = {};
      if (this.list) {
        data = this.list;
      }
      return data;
    },
    total() {
      let dataTotal = 0;
      if (this.list) {
        dataTotal = this.$attrs.total;
      }
      return dataTotal;
    },
    NAMED_ROLES() {
      return NAMED_ROLES;
    },
    selectProperties() {
      return {
        items: this.resourceList,
        multiple: 'true',
      };
    },
    filteredTickets() {
      if (!this.selectedCI.length) {
        return this.tickets;
      }

      return this.tickets.filter((ticket) => {
        const resourceId = ticket?.affectedResource?.id;

        return this.selectedCI.includes(resourceId);
      });
    },
  },
  methods: {
    formFiltersConfigurationPendApro(aux) {
      const filterRange = { ...aux };
      filterRange.properties.forEach((i) => {
        if (i.alias === 'open_date') {
          i.params.rangeMonth = null; // eslint-disable-line
        }
        if (i.alias === 'last_mod_dt') {
          i.dependency.visibility = 'false'; // eslint-disable-line
        }
        if (i.alias === 'resolve_date') {
          i.dependency.visibility = 'false'; // eslint-disable-line
        }
      });
      return filterRange;
    },
    formFiltersConfigurationRchz(aux) {
      const filterRange = { ...aux };
      filterRange.properties.forEach((i) => {
        if (i.alias === 'open_date') {
          i.params.rangeMonth = null; // eslint-disable-line
        }
        if (i.alias === 'last_mod_dt') {
          i.dependency.visibility = 'false'; // eslint-disable-line
        }
        if (i.alias === 'resolve_date') {
          i.dependency.visibility = 'true'; // eslint-disable-line
        }
      });
      return filterRange;
    },
    formFiltersConfigurationAppval(aux) {
      const filterRange = { ...aux };
      filterRange.properties.forEach((i) => {
        if (i.alias === 'open_date') {
          i.params.rangeMonth = 3; // eslint-disable-line
        }
        if (i.alias === 'last_mod_dt') {
          i.dependency.visibility = 'true'; // eslint-disable-line
        }
        if (i.alias === 'resolve_date') {
          i.dependency.visibility = 'false'; // eslint-disable-line
        }
      });
      return filterRange;
    },
    clickChip(label) {
      if (!this.listFilters.find((filter) => filter.label === label).active) {
        this.listFilters.forEach((filter, index) => {
          if (filter.label === label && !filter.active) {
            this.listFilters[index].active = true;
          } else if (filter.label !== label) {
            this.listFilters[index].active = false;
          }
        });
        this.rangeFilter = label;
        this.filtersForms = {};
        const focusOut = document.getElementById(label);
        if (focusOut) {
          setTimeout(() => {
            focusOut.click();
          }, 0);
        }
        this.$refs.formFilters.clearFormData();
      }
    },
    textIcon(ticket) {
      if (ticket?.status?.code) {
        const result = this.$getConst(`initialFilters.filterStatus.${ticket.status.code}.initials`);
        return result;
      }
      return '';
    },
    colors(status) {
      if (status) {
        const result = this.$getConst(`initialFilters.filterStatus.${status}.color`);
        return result;
      }
      return '';
    },
    async search(action, start, size, filters) {
      this.firstSearch = false;
      const {
        sort, ticketType, asc,
      } = this;
      const statusFilter = this.listFilters.find((f) => f.active);
      await this.$emit('request', {
        type: 'approvals',
        args: {
          start,
          size,
          filters: filters || this.filtersForms,
          sort,
          ticketType,
          asc,
          action,
          status: statusFilter ? statusFilter.label : 'PEND_APRO',
        },
      });
      this.filtersForms = {};
      this.firstSearch = true;
    },
    async exportTickets() {
      this.exportLoading = true;
      const exportType = this.$getConst(`ticketExport.${this.ticketType}`);
      const file = await this.$api
        .getClient(exportType)
        .exportApprovalsXLS(this.filtersForms);
      const uInt8Array = new Uint8Array(file.data);
      let i = uInt8Array.length;
      const binaryString = new Array(i);
      // eslint-disable-next-line no-plusplus
      while (i--) {
        binaryString[i] = String.fromCharCode(uInt8Array[i]);
      }
      const data = binaryString.join('');
      const base64 = window.btoa(data);

      const blob = b64toBlob(
        base64,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      );
      saveAs(blob, 'download.xlsx');
      this.exportLoading = false;
    },
    getOpenedBy(ticket) {
      const openedBy = ['requestedBy', 'customer'].map(
        (key) => (ticket[key] || {}).name,
      );
      return openedBy.filter((key, i, arr) => arr.indexOf(key) === i);
    },
    getAsignee(ticket) {
      return ['group', 'asignee'].map((key) => (ticket[key] || {}).name);
    },
    submit({ data }) {
      let query = {};
      this.start = 0;

      // value of input search
      this.dataSearch = this.$refs.filterComponent.$children[0].value;
      const searchInput = this.$refs.filterComponent.$children[0].value;
      if (data) {
        Object.entries(data).forEach(([key, value]) => {
          if (key.includes('date') || key.includes('datetime') || key.includes('last')) {
            data[key] = value.replace(' - ', '::'); // eslint-disable-line
          }
        });
        query = {
          ...data,
        };
      }
      if (searchInput) {
        query.search = searchInput;
      }
      // Avoid error to generate url
      this.$router.push({ name: this.$route.name, query }).catch(() => {});
      this.search('list', 0, 25, query);
      this.pagesize = 25;
      this.selectedCI = [];
    },
    scrollTickets(increment) {
      if (this.pagesize <= this.total) {
        this.scroll = true;
        this.search('scroll', this.pagesize, increment, this.filtersForms);
        this.pagesize += increment;
      } else {
        this.scroll = false;
      }
    },
    ckeckAll() {
      if (this.checkAll) {
        this.filteredTickets.forEach((ticket, i) => {
          if (i < 10) {
            this.selected = this.selected.filter((select) => select !== ticket);
          }
        });
        this.checkAll = false;
      } else {
        this.filteredTickets.forEach((ticket, i) => {
          if (!this.selected.includes(ticket) && i < 10) {
            this.selected.push(ticket);
          }
        });
        this.checkAll = true;
      }
    },
    openAproveAll() {
      if (this.showRejectAll) {
        this.showRejectAll = false;
      }
      this.showApproveAll = !this.showApproveAll;
    },
    openRejectAll() {
      if (this.showApproveAll) {
        this.showApproveAll = false;
      }
      this.showRejectAll = !this.showRejectAll;
    },
    closeActionsAll() {
      this.showApproveAll = false;
      this.showRejectAll = false;
    },
    refresh() {
      this.selected = [];
      this.search('list', this.pagesize, this.filtersForms);
    },
    closeActions() {
      this.openApprover = false;
      this.openReject = false;
      this.refresh();
    },
    onApplicationsSelected(data) {
      this.checkAll = false;
      this.selected = [];
      this.selectedCI = Array.isArray(data.value) // eslint-disable-line
        ? data.value
        : (data.value ? [data.value] : []);
    },
  },
  async created() {
    this.search('list', 0, 25, this.filters);
    this.filtersForms = this.filters;
    this.firstSearch = true;
    this.listFilters = [
      {
        active: true,
        label: 'PEND_APRO',
      },
      {
        active: false,
        label: 'RCHZ',
      },
      {
        active: false,
        label: 'APPVAL',
      },
    ];
  },

};
</script>

<style lang="scss" scoped>
.item-title {
  font-size: 1rem;
}
.v-messages {
  display: none !important;
}

.item-title-end {
  //order: 4;
  //padding-left: 0.5rem;
}
  .container__chip {
    margin-left: 1rem;
  }
  .chip__active {
    color: #27846d !important;
    background-color: #e6f1ee !important;
    border: 1px solid #27846d !important;
  }
  .chip__filter {
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 32px;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
  }
  .showMobile {
    display: none !important;
  }
  .showMobile .v-slide-group__next,
  .showMobile .v-slide-group__prev {
    min-width: initial !important;
  }
  .inlineFlexMW90{
    display: inline-flex;
    width: 95%;
  }
  .titleTicket{
    font-size: 0.95rem !important;
  }
  .alignItemCenter{
    display: flex;
    align-items: center !important;
  }
  .initialColor{
    font-size: 0.5rem !important;
    //margin-right: 0.5rem;
  }
  .initialColorIcon{
    color: #ffffff !important;
    font-size: 14px !important;
  }
  .exportActions{
    margin-left: auto;
    padding-right: 1rem;
  }
  @media screen and (max-width: 600px) {
    .titleTicket{
      font-size: 0.85rem !important;
    }
    .showWeb {
      display: none !important;
    }
    .showMobile {
      display: flex !important;
    }
    .inlineFlexMW90{
      width: 90%;
    }
  }
  @media screen and (max-width: 960px) {
    .showMobile {
      display: flex !important;
      margin-bottom: 0.5rem;
    }
  }
</style>
